
import { z } from "zod";

const ratingScale = z.enum([
  "Stämmer inte alls",
  "Stämmer dåligt",
  "Varken eller",
  "Stämmer delvis",
  "Stämmer helt"
]);

export const adminFormSchema = z.object({
  id: z.string(),
  full_name: z.string().min(2, "Name must be at least 2 characters"),
  years_experience: z.number().min(0).max(100),
  specialization: z.string(),
  gender: z.string(),
  age: z.number().min(18, "Must be at least 18 years old").max(100),
  languages: z.array(z.string()),
  birth_country: z.string(),
  sweden_arrival_date: z.date().nullable().optional(),
  education_level: z.string(),
  occupation: z.string(),
  workplace: z.string(),
  previous_group_experience: z.boolean(),
  previous_groups: z.string().nullable(),
  fos_groups_count: z.number().min(0),
  social_services_knowledge: z.number().min(1).max(5),
  leadership_confidence: z.object({
    equal_knowledge: z.string(),
    more_knowledge: z.string(),
    different_opinion: z.string(),
    disagreement: z.string(),
    disinterested: z.string(),
    enthusiastic: z.string(),
  }),
  has_consent: z.boolean(),
  has_data_consent: z.boolean(),
});

export const groupLeaderResponseSchema = z.object({
  meeting_number: z.number().min(1).max(5),
  date: z.string(),
  participants_count: z.number().min(0),
  completed_all_moments: ratingScale,
  missing_moments: z.string().optional(),
  parent_engagement: ratingScale,
  engaged_moments: z.array(z.string()),
  supportive_participants: ratingScale,
  good_delivery: ratingScale,
  difficult_moments: z.array(z.string()).optional(),
  sufficient_knowledge: ratingScale,
  missing_knowledge: z.string().optional(),
  confirmed_participants: ratingScale,
  activated_group: ratingScale,
  maintained_structure: ratingScale,
  group_leader_id: z.string(),
  other_comments: z.string().optional(),
});

export type AdminFormValues = z.infer<typeof adminFormSchema>;
export type GroupLeaderResponse = z.infer<typeof groupLeaderResponseSchema>;
